var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConnectFbIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.88 2.667H5.19A2.525 2.525 0 002.667 5.19V18.88a2.525 2.525 0 002.524 2.525h6.751l.012-6.695h-1.74a.41.41 0 01-.41-.41l-.009-2.158a.41.41 0 01.41-.412h1.737V9.644c0-2.42 1.478-3.738 3.637-3.738h1.772a.41.41 0 01.41.41v1.82a.41.41 0 01-.41.41l-1.087.001c-1.174 0-1.401.558-1.401 1.377v1.805h2.58a.41.41 0 01.407.46l-.256 2.157a.41.41 0 01-.407.363h-2.313l-.011 6.695h4.016a2.525 2.525 0 002.525-2.524V5.19a2.525 2.525 0 00-2.525-2.524z",
    fill: "url(#connect-fb-icon_svg__paint0_linear_7070_120623)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.88 2.667H5.19A2.525 2.525 0 002.667 5.19V18.88a2.525 2.525 0 002.524 2.525h6.751l.012-6.695h-1.74a.41.41 0 01-.41-.41l-.009-2.158a.41.41 0 01.41-.412h1.737V9.644c0-2.42 1.478-3.738 3.637-3.738h1.772a.41.41 0 01.41.41v1.82a.41.41 0 01-.41.41l-1.087.001c-1.174 0-1.401.558-1.401 1.377v1.805h2.58a.41.41 0 01.407.46l-.256 2.157a.41.41 0 01-.407.363h-2.313l-.011 6.695h4.016a2.525 2.525 0 002.525-2.524V5.19a2.525 2.525 0 00-2.525-2.524z",
    fill: "#A5BBD4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "connect-fb-icon_svg__paint0_linear_7070_120623",
    x1: 21.778,
    y1: 2.839,
    x2: 2.842,
    y2: 21.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })))));
}

export default __webpack_public_path__ + "./fonts/connect-fb-icon.d1d41cb965ad2351a81078888b3399ba.svg";
export { SvgConnectFbIcon as ReactComponent };